import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';

// Dark-Mode beim Start initialisieren (vor erstem Render)
const savedTheme = localStorage.getItem('theme');
if (savedTheme === 'dark' || (!savedTheme && window.matchMedia('(prefers-color-scheme: dark)').matches)) {
  document.documentElement.classList.add('dark');
}

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Root element #root nicht gefunden — index.html fehlerhaft.');
}

ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
